<header class="header">
    <nav class="navbar navbar-expand-lg home-navbar" >
        <a class="navbar-brand"><img src="assets/img/scentrelogo.png" alt="Logo" class="headerlogo"/></a>
    </nav>
</header>
